import { jsonp } from '@ifeng-fe/ui_base';
import { getUserid, isArray, formatPlayTimes } from '@ifeng-fe/container_content/common/client/utils/utils';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
let apiBaseUrl = apiUrl;
/* eslint-enable no-undef */

if (typeof window !== 'undefined' && /\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/c';
}

// 获取视频播放数
const getVideoComment = async vid => {
    // const { schemaCheck } = await import('./validate');

    let apiUrl = '//survey.news.ifeng.com/api/getaccumulatorweight?';

    // 接口拼接
    if (vid.length > 0) {
        vid.forEach(item => {
            apiUrl += `key[]=${item}&`;
        });
    }

    let data = await jsonp(apiUrl, {
        data: {
            format: 'js',
            serviceid: 1,
        },
        jsonpCallback: 'getVideoComment1',
        cache: false,
    });
    // const requestUrl = `//survey.news.ifeng.com/api/getaccumulatorweight?format=js&key=${vid}&callback=getaccumulator`;

    // data = schemaCheck(data.data, 'voteNumSchema', requestUrl);
    data = data.data;

    return data ? data : null;
};

const getVideoRecomlist = async (guid, title) => {
    let _title = title || '';

    _title = _title.replace(/[\r\n]/g, '');

    try {
        const data = await jsonp(
            `${apiBaseUrl}/api/videoRecom/getRecomlist/v2/${getUserid() || 'false'}/${guid}/${encodeURIComponent(
                encodeURIComponent(_title),
            )}/getVideoRecomlist1`,
            {
                jsonpCallback: 'getVideoRecomlist1',
                cache: false,
            },
        );

        if (data && data.data) {
            data.data = data.data.sort(() => (Math.random() > 0.5 ? 1 : -1));
        }

        return data ? data : null;
    } catch (e) {
        console.error(e);
    }
};

// 获取自媒体账号的视频列表
const getWemediaVideoList = async id => {
    try {
        return await jsonp(`${apiBaseUrl}/api/video/getWeMediaListData/${id}/getWemediaVideoList1`, {
            jsonpCallback: 'getWemediaVideoList1',
            cache: false,
        });
    } catch (e) {
        console.error(e);
    }
};

export { getVideoComment, getVideoRecomlist, getWemediaVideoList };
